// 🔧 privacy.js
// ✅ Purpose: Public privacy policy page for Let's Go Vote
// ✅ Features:
// - SEO Helmet metadata
// - Explains how user and event data is handled
// - Separates privacy content from Terms & Conditions
// - Builds trust with voters and organizers

import React from "react";
import SeoHead from "../../components/seo_head";
import { PUBLIC_PAGE_SEO } from "../../constants/marketing_pages";

const Privacy = () => {
  return (
    <>
      <SeoHead {...PUBLIC_PAGE_SEO.privacy} />

      <section id="top-content" className="container-fluid py-5">
        <div className="container">
          <div className="row mb-4">
            <div className="col text-start">
              <h1 className="display-5">🔐 Privacy Policy</h1>
              <p className="lead text-muted">
                How Let's Go Vote handles user, event, and participation data.
              </p>
            </div>
          </div>

          <div className="white-section p-4 rounded shadow-sm bg-white text-start">
            <h2 className="h4 mb-3">Information we collect</h2>
            <p>
              Let's Go Vote may collect account information, event participation
              data, votes, event entries, volunteer signups, sponsor information,
              auction activity, and contact form submissions when those features
              are used.
            </p>

            <h2 className="h4 mt-5 mb-3">How information is used</h2>
            <p>
              Information is used to operate events, support voting integrity,
              manage event features, communicate with users when appropriate,
              and help organizers run their events.
            </p>

            <h2 className="h4 mt-5 mb-3">Event organizer access</h2>
            <p>
              Authorized event administrators and managers may access event-specific
              data needed to manage their event, such as users, entries, votes,
              volunteers, sponsors, and auction information.
            </p>

            <h2 className="h4 mt-5 mb-3">Data sharing</h2>
            <p>
              Let's Go Vote does not sell personal information. Event-related data
              may be visible to authorized event organizers when needed to run
              their event.
            </p>

            <h2 className="h4 mt-5 mb-3">SMS consent and phone numbers</h2>
            <p>
              If you separately opt in to transactional Auction SMS alerts, we
              store your phone number and consent record to deliver requested
              alerts and honor opt-out requests. SMS opt-in consent is not sold,
              rented, shared, or transferred to third parties for their marketing
              purposes. See the <a href="/sms-alerts">SMS Alerts Terms</a>.
            </p>

            <h2 className="h4 mt-5 mb-3">Security</h2>
            <p>
              We use reasonable technical and administrative measures to help
              protect stored information and control access to event data.
            </p>

            <h2 className="h4 mt-5 mb-3">Questions</h2>
            <p>
              Privacy questions may be sent to hello@letsgovote.app.
            </p>

            <p className="mt-5 small text-muted">
              Last Updated: October 29, 2026
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;
